import { Modal }              from '@widesk-ui/components/modal/Modal';
import { Action }             from '@widesk-ui/components/ButtonActions';
import confirmModelMessage    from '@widesk-ui/tools/actionModel/confirmModelMessage';
import ucFirst                from '@widesk-core/tools/ucFirst';
import { message }            from '@widesk-ui/hooks/useMessage';
import { DisconnectOutlined } from '@ant-design/icons';
import { WithRenderName }     from '@widesk-ui/mixins/ApiModelRenderName';
import { WithLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import ApiModel               from '@widesk-core/models/ApiModel';

type UnlinkModel = ApiModel & WithLocalizedLabel & WithRenderName;
type UnlinkOptions<M extends UnlinkModel> = {
	modelName?: string;
	before?: () => void;
	callback?: () => void;
	content?: string;
	redirect?: string;
	success?: string;
	title?: string;
	hideModelName?: boolean;
	renderModelLabel?: (m: M) => string;
	actionProps?: Partial<Action>;
};

const unlinkModelConfirm = <M extends UnlinkModel>(m: M, options: UnlinkOptions<M> = {}) => {
	const label = options.renderModelLabel ? options.renderModelLabel(m) : m.modelLabel;
	const title = options.title
		|| confirmModelMessage(m, { actionLabel: 'détacher', hideModelName: options.hideModelName, modelLabel: label, modelName: options.modelName });

	return Modal.confirm({
		okType: 'danger',
		content: options.content,
		onOk: async () => {
			try {
				if (options.before) {
					await options.before();
				}

				await m.destroy();

				if (options.callback) {
					options.callback();
				}

				const success = options.success
					|| ucFirst(`L'élément ${options?.hideModelName ? '' : `${m.localize()} `}"${label}" a bien été détaché.`);

				message.success(success);
			} catch (err) {
				message.exception(err);
			}
		},
		title,
	});
};

const actionUnlinkModel = <M extends UnlinkModel>(
	model: M,
	options?: UnlinkOptions<M>,
) => {
	return {
		danger: true,
		icon: <DisconnectOutlined />,
		label: `Détacher l'élément` + (options?.hideModelName ? '' : ` - ${options?.modelName || model.localize()}`),
		onClick: async () => unlinkModelConfirm(model, options),

		...options?.actionProps,
	};
};

export default actionUnlinkModel;
